const DPPProductTypes = {
  FETCH_DPP_DATA_BY_ID: 'FETCH_DPP_DATA_BY_ID',
  CLEAR_DPP_LIB_DATA: 'CLEAR_DPP_LIB_DATA',
  GET_PRODUCT_DETAILS: 'GET_PRODUCT_DETAILS',
  GET_FACTORIES_DETAIL: 'GET_FACTORIES_DETAIL',
  GET_DPP_BOM: 'GET_DPP_BOM',
  FETCH_SELECTED_BOM_DATA: 'FETCH_SELECTED_BOM_DATA',
};

export default DPPProductTypes;
